import cn from 'classnames';

type Props = {
  value: string;
  className?: string;
  e2eId?: string;
};

export const FormattedIdentifier = ({
  value,
  className = '',
  e2eId
}: Props) => {
  if (!value) {
    return <p className="text-sm">N/A</p>;
  }

  return (
    <p className={cn(className)} aria-label={value} title={value}>
      <span data-testid={e2eId}>{value}</span>
    </p>
  );
};
